export const setWebSite = (): void => {
  const currentHost = useCurrentHost()
  useHead({
    link: [
      {
        rel: "canonical",
        href: currentHost
      },
      {
        rel: "alternate",
        hreflang: "en-KE",
        href: currentHost
      }
    ],
    script: [
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "OnlineStore",
            "name": "Kilimall Kenya",
            "alternateName": "Kilimall",
            "url": `${currentHost}/`,
            "logo": "https://img.kilimall.com/c/h5/logo_icon_164_x3.png",
            "description": "Kenya's leading online shopping mall offering affordable electronics, home appliances, fashion, and more with secure payments like M-Pesa and doorstep delivery.",
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "Customer Service",
              "telephone": "+254711082780",
              "email": "help@kilimall.com"
            },
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "KE",
              "addressRegion": "Nairobi",
              "addressLocality": "Nairobi",
              "postalCode": "00100",
              "streetAddress": "Athi 55, Mombasa Road, P.O.Box 29980-00100",
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "applicableCountry": ["KE"],
              "returnPolicyCountry": "KE",
              "merchantReturnDays": 7,
              "returnMethod": "https://schema.org/ReturnAtKiosk",
              "returnFees": "https://schema.org/FreeReturn",
              "merchantReturnLink": `${currentHost}/help-center/oh_3498?c_id=1078&s_id=1004&bs_type=1`,
            },
            "sameAs": [
              "https://www.facebook.com/kilimall",
              "https://x.com/Kilimall"
            ]
          }
        )
      }
    ]
  })
}